import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IDiscountPassengerCountRulePassengerTypeAttributes extends IModelAttributes {
	discountPassengerCountRuleId: string;
	passengerTypeId: string;

	discountPassengerCountRule: Models.DiscountPassengerCountRule | Models.IDiscountPassengerCountRuleAttributes;
	passengerType: Models.PassengerTypeEntity | Models.IPassengerTypeEntityAttributes;
}

@entity('DiscountPassengerCountRulePassengerType')
export default class DiscountPassengerCountRulePassengerType
	extends Model
	implements IDiscountPassengerCountRulePassengerTypeAttributes
{
	@observable
	@attribute()
	public discountPassengerCountRuleId: string;

	@observable
	@attribute()
	public passengerTypeId: string;

	@observable
	@attribute({ isReference: true })
	public discountPassengerCountRule: Models.DiscountPassengerCountRule;

	@observable
	@attribute({ isReference: true })
	public passengerType: Models.PassengerTypeEntity;

	constructor(attributes?: Partial<IDiscountPassengerCountRulePassengerTypeAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.discountPassengerCountRuleId) {
				this.discountPassengerCountRuleId = attributes.discountPassengerCountRuleId;
			}
			if (attributes.passengerTypeId) {
				this.passengerTypeId = attributes.passengerTypeId;
			}

			if (attributes.discountPassengerCountRule) {
				if (attributes.discountPassengerCountRule instanceof Models.DiscountPassengerCountRule) {
					this.discountPassengerCountRule = attributes.discountPassengerCountRule;
					this.discountPassengerCountRuleId = attributes.discountPassengerCountRule.id;
				} else {
					this.discountPassengerCountRule = new Models.DiscountPassengerCountRule(
						attributes.discountPassengerCountRule,
					);
					this.discountPassengerCountRuleId = this.discountPassengerCountRule.id;
				}
			} else if (attributes.discountPassengerCountRuleId !== undefined) {
				this.discountPassengerCountRuleId = attributes.discountPassengerCountRuleId;
			}

			if (attributes.passengerType) {
				if (attributes.passengerType instanceof Models.PassengerTypeEntity) {
					this.passengerType = attributes.passengerType;
					this.passengerTypeId = attributes.passengerType.id;
				} else {
					this.passengerType = new Models.PassengerTypeEntity(attributes.passengerType);
					this.passengerTypeId = this.passengerType.id;
				}
			} else if (attributes.passengerTypeId !== undefined) {
				this.passengerTypeId = attributes.passengerTypeId;
			}
		}
	}
}
